import {Component, EventEmitter} from '@angular/core';
import { Input } from '@angular/core';
import {FlowDescriptionRule} from "@app/netscope/model/data-models";

@Component({
  standalone: false,
  selector: 'app-flows-descriptions-edit-component',
  templateUrl: './flows-descriptions-edit-component.component.html',
  styleUrl: './flows-descriptions-edit-component.component.css'
})
export class FlowsDescriptionsEditComponentComponent {
  // Only holds the description part of a rule, its network aspect being edited by
  // FlowsDescriptionsNetworkRuleEditComponent
  @Input()
  flowDescription: FlowDescriptionRule;

  @Input()
  flowDescriptionComponentUpdater: EventEmitter<any>;

  suggestedDataClassifications = FlowDescriptionRule.suggestedDataClassifications;
  newDataClassification: string = "";

  addDataClassification = () => {
    this.flowDescription.addDataClassification(this.newDataClassification);
    this.newDataClassification = "";
  }

  deleteDataClassification = (dataClassification: string) => {
    this.flowDescription.deleteDataClassification(dataClassification);
  }
}
